/* Nominal Lookbook: chapter links + "Shop the look" drawer. Loaded once per page (guarded). */
(function () {
  if (window.__nmLookbook) return;
  window.__nmLookbook = true;

  var METAL = /colou?r|metal|finish/i;
  var SWATCH = [[/rose/i, '#E2B4A2'], [/silver|steel|white/i, '#CDD0D4'], [/gold/i, '#D9B86C']];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c, sym) { var d = Math.floor(c / 100), r = c % 100; return (sym || '$') + d.toLocaleString('en-US') + (r ? '.' + (r < 10 ? '0' : '') + r : ''); }
  function swatch(v) { for (var i = 0; i < SWATCH.length; i++) if (SWATCH[i][0].test(v)) return SWATCH[i][1]; return '#ddd'; }
  function metalMatch(value, want) {
    var v = String(value).toLowerCase();
    if (want === 'rose') return v.indexOf('rose') > -1;
    if (want === 'silver') return /silver|steel|white/.test(v);
    return v.indexOf('gold') > -1 && v.indexOf('rose') === -1;
  }

  /* ---------- Chapter links in the intro ---------- */
  function buildNav() {
    var nav = document.querySelector('[data-nm-lb-nav]');
    if (!nav) return;
    var chapters = document.querySelectorAll('[data-nm-lb-chapter]');
    nav.innerHTML = Array.prototype.map.call(chapters, function (c) {
      if (!c.dataset.title) return '';
      return '<a href="#' + esc(c.id) + '">' + esc(c.dataset.title) + '<sup>' + esc(c.dataset.count || '') + '</sup></a>';
    }).join('');
    nav.hidden = !nav.innerHTML;
  }

  /* ---------- Drawer ---------- */
  var dr, panel, body, list, foot, allBtn, note, mediaImg, heroImg, titleEl, creditEl, lastFocus, look, rows = [];

  function buildDrawer() {
    dr = document.createElement('div');
    dr.className = 'nm-lb-dr';
    dr.hidden = true;
    dr.innerHTML =
      '<div class="nm-lb-dr__scrim" data-nm-lb-close></div>' +
      '<div class="nm-lb-dr__panel" role="dialog" aria-modal="true" aria-labelledby="nm-lb-dr-title" tabindex="-1">' +
        '<div class="nm-lb-dr__media"><img alt=""></div>' +
        '<button type="button" class="nm-lb-dr__close" data-nm-lb-close aria-label="Close"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
        '<div class="nm-lb-dr__body">' +
          '<div class="nm-lb-dr__hero"><img alt=""></div>' +
          '<h2 class="nm-lb-dr__title" id="nm-lb-dr-title">Shop the look</h2>' +
          '<p class="nm-lb-dr__credit"></p>' +
          '<ul class="nm-lb-dr__list"></ul>' +
        '</div>' +
        '<div class="nm-lb-dr__foot"><button type="button" class="nm-lb-dr__all"></button><p class="nm-lb-dr__note" role="status" aria-live="polite"></p></div>' +
      '</div>';
    document.body.appendChild(dr);
    panel = dr.querySelector('.nm-lb-dr__panel');
    body = dr.querySelector('.nm-lb-dr__body');
    list = dr.querySelector('.nm-lb-dr__list');
    foot = dr.querySelector('.nm-lb-dr__foot');
    allBtn = dr.querySelector('.nm-lb-dr__all');
    note = dr.querySelector('.nm-lb-dr__note');
    mediaImg = dr.querySelector('.nm-lb-dr__media img');
    heroImg = dr.querySelector('.nm-lb-dr__hero img');
    titleEl = dr.querySelector('.nm-lb-dr__title');
    creditEl = dr.querySelector('.nm-lb-dr__credit');

    dr.addEventListener('click', function (e) { if (e.target.closest('[data-nm-lb-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (dr.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    });
    list.addEventListener('click', onListClick);
    list.addEventListener('change', onListChange);
    allBtn.addEventListener('click', addAll);
  }

  function trapFocus(e) {
    var f = panel.querySelectorAll('button:not([disabled]), a[href], select');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(card, fromHash) {
    if (!dr) buildDrawer();
    var data;
    try { data = JSON.parse(card.querySelector('[data-nm-lb-data]').textContent); } catch (err) { return; }
    look = data;
    look.card = card;
    look.sym = (card.closest('[data-nm-lb-chapter]') || {}).dataset ? card.closest('[data-nm-lb-chapter]').dataset.sym : '$';
    lastFocus = document.activeElement;

    var src = data.image ? data.image : '';
    mediaImg.src = src; heroImg.src = src;
    mediaImg.style.objectPosition = heroImg.style.objectPosition = data.focal || 'center';
    mediaImg.alt = heroImg.alt = data.alt || '';
    titleEl.textContent = 'Shop the look';
    if (data.credit) {
      var handle = '@' + data.credit;
      creditEl.innerHTML = 'Styled by ' + (data.creditUrl ? '<a href="' + esc(data.creditUrl) + '" target="_blank" rel="noopener">' + esc(handle) + '</a>' : esc(handle));
      creditEl.hidden = false;
    } else { creditEl.hidden = true; }

    rows = data.products.filter(function (p) { return p.available; }).map(makeRow);
    list.innerHTML = rows.map(rowHtml).join('');
    rows.forEach(function (r, i) { r.el = list.children[i]; paint(r); });
    note.textContent = ''; note.classList.remove('is-error');
    paintAll();

    dr.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    body.scrollTop = 0;
    requestAnimationFrame(function () { requestAnimationFrame(function () { dr.classList.add('is-open'); }); });
    panel.focus({ preventScroll: true });
    if (!fromHash && history.replaceState) history.replaceState(null, '', '#' + card.id);
  }

  function close() {
    if (!dr || dr.hidden) return;
    dr.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (history.replaceState && /^#look-/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search);
    setTimeout(function () { dr.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Rows ---------- */
  function makeRow(p) {
    var r = { p: p, metalIdx: p.options.findIndex(function (o) { return METAL.test(o); }), sel: {}, added: false };
    r.other = p.options.map(function (o, i) { return i; }).filter(function (i) { return i !== r.metalIdx; });
    r.metals = [];
    if (r.metalIdx > -1) p.variants.forEach(function (v) { var m = v.o[r.metalIdx]; if (r.metals.indexOf(m) === -1) r.metals.push(m); });
    /* Start on the metal in the photo, if this piece comes in it and it's in stock */
    if (r.metalIdx > -1) {
      var want = r.metals.filter(function (m) { return metalMatch(m, look.metal) && p.variants.some(function (v) { return v.a && v.o[r.metalIdx] === m; }); })[0];
      var any = r.metals.filter(function (m) { return p.variants.some(function (v) { return v.a && v.o[r.metalIdx] === m; }); })[0];
      r.sel[r.metalIdx] = want || any || r.metals[0];
    }
    /* Options with a single value need no choice */
    r.other.forEach(function (i) { var vals = values(r, i); if (vals.length === 1) r.sel[i] = vals[0]; });
    return r;
  }
  function values(r, i) {
    var out = [];
    r.p.variants.forEach(function (v) {
      if (r.metalIdx > -1 && i !== r.metalIdx && v.o[r.metalIdx] !== r.sel[r.metalIdx]) return;
      if (out.indexOf(v.o[i]) === -1) out.push(v.o[i]);
    });
    return out;
  }
  function variant(r) {
    return r.p.variants.filter(function (v) { return v.o.every(function (x, i) { return r.sel[i] === x; }); })[0] || null;
  }
  function display(r) {
    /* Variant to show price/photo for, even before a size is chosen */
    return variant(r) || r.p.variants.filter(function (v) { return r.metalIdx < 0 || v.o[r.metalIdx] === r.sel[r.metalIdx]; })[0] || r.p.variants[0];
  }

  function rowHtml(r, n) {
    var p = r.p, h = '';
    h += '<li class="nm-lb-dr__row" data-i="' + n + '">';
    h += '<a class="nm-lb-dr__thumb" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img alt="" loading="lazy"></a>';
    h += '<div><a class="nm-lb-dr__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
    h += '<span class="nm-lb-dr__price"><b></b><s></s></span>';
    h += '<div class="nm-lb-dr__opts">';
    if (r.metals.length > 1) {
      h += '<div class="nm-lb-dr__metals" role="group" aria-label="' + esc(p.options[r.metalIdx]) + '">';
      r.metals.forEach(function (m) {
        h += '<button type="button" class="nm-lb-dr__metal" data-metal="' + esc(m) + '" style="--sw:' + swatch(m) + '" aria-label="' + esc(m) + '"></button>';
      });
      h += '</div><span class="nm-lb-dr__metal-name"></span>';
    } else if (r.metals.length === 1) {
      h += '<span class="nm-lb-dr__metal-name">' + esc(r.metals[0]) + '</span>';
    }
    r.other.forEach(function (i) {
      if (values(r, i).length > 1) h += '<select class="nm-lb-dr__select" data-opt="' + i + '" aria-label="' + esc(p.options[i]) + '"></select>';
    });
    h += '</div></div>';
    h += '<button type="button" class="nm-lb-dr__add" aria-label="Add ' + esc(p.title) + ' to cart">+ Add</button>';
    h += '<p class="nm-lb-dr__msg" role="status" aria-live="polite"></p>';
    h += '</li>';
    return h;
  }

  function paint(r) {
    var el = r.el, v = display(r);
    el.querySelector('.nm-lb-dr__price b').textContent = money(v.p, look.sym);
    el.querySelector('.nm-lb-dr__price s').textContent = v.c > v.p ? money(v.c, look.sym) : '';
    var img = el.querySelector('.nm-lb-dr__thumb img');
    var src = v.img || r.p.img;
    if (src && img.getAttribute('src') !== src) img.src = src;
    Array.prototype.forEach.call(el.querySelectorAll('[data-metal]'), function (b) {
      var m = b.getAttribute('data-metal');
      b.setAttribute('aria-pressed', m === r.sel[r.metalIdx] ? 'true' : 'false');
      b.disabled = !r.p.variants.some(function (x) { return x.a && x.o[r.metalIdx] === m; });
    });
    var mn = el.querySelector('.nm-lb-dr__metal-name');
    if (mn && r.metals.length > 1) mn.textContent = r.sel[r.metalIdx] || '';
    Array.prototype.forEach.call(el.querySelectorAll('select[data-opt]'), function (s) {
      var i = +s.getAttribute('data-opt');
      var vals = values(r, i);
      if (r.sel[i] && vals.indexOf(r.sel[i]) === -1) delete r.sel[i];
      s.innerHTML = '<option value="">' + esc(r.p.options[i]) + '</option>' + vals.map(function (x) {
        var ok = r.p.variants.some(function (vv) { return vv.a && vv.o[i] === x && (r.metalIdx < 0 || vv.o[r.metalIdx] === r.sel[r.metalIdx]); });
        return '<option value="' + esc(x) + '"' + (ok ? '' : ' disabled') + (r.sel[i] === x ? ' selected' : '') + '>' + esc(x) + (ok ? '' : ' (sold out)') + '</option>';
      }).join('');
    });
    var btn = el.querySelector('.nm-lb-dr__add');
    var vv = variant(r);
    if (r.added) { btn.className = 'nm-lb-dr__add is-done'; btn.innerHTML = 'Added &#10003;'; btn.disabled = true; }
    else if (vv && !vv.a) { btn.className = 'nm-lb-dr__add'; btn.textContent = 'Sold out'; btn.disabled = true; }
    else { btn.className = 'nm-lb-dr__add'; btn.textContent = '+ Add'; btn.disabled = false; }
  }

  function pending() { return rows.filter(function (r) { return !r.added; }); }

  function paintAll() {
    var left = pending();
    if (!left.length) {
      allBtn.disabled = true;
      allBtn.innerHTML = 'All pieces added &#10003;';
      return;
    }
    allBtn.disabled = false;
    var total = 0, was = 0;
    left.forEach(function (r) { var v = display(r); total += v.p; was += Math.max(v.c, v.p); });
    var pct = +look.pct || 0;
    var label = rows.length === left.length ? 'Add all ' + left.length : 'Add the other ' + left.length;
    var price = money(pct && look.code ? Math.round(total * (100 - pct) / 100) : total, look.sym);
    var strike = (pct && look.code) ? total : (was > total ? was : 0);
    allBtn.innerHTML = '<span>' + label + (left.length === 1 ? ' piece' : ' pieces') + '</span><span>' + price + (strike ? ' <s>' + money(strike, look.sym) + '</s>' : '') + '</span>';
    if (!note.classList.contains('is-error')) note.textContent = pct && look.code ? 'Extra ' + pct + '% off when you add the full look. Applied at checkout.' : '';
  }

  function onListClick(e) {
    var li = e.target.closest('.nm-lb-dr__row');
    if (!li) return;
    var r = rows[+li.getAttribute('data-i')];
    var mb = e.target.closest('[data-metal]');
    if (mb) {
      if (r.added && r.sel[r.metalIdx] !== mb.getAttribute('data-metal')) r.added = false;
      r.sel[r.metalIdx] = mb.getAttribute('data-metal');
      paint(r); paintAll();
      return;
    }
    if (e.target.closest('.nm-lb-dr__add')) {
      var v = needChoice(r);
      if (!v) return;
      setMsg(r, '');
      busy(r, true);
      cartAdd([{ id: v.id, quantity: 1 }]).then(function () {
        r.added = true; busy(r, false); paint(r); paintAll();
        refreshCart(false, 1);
      }).catch(function (err) {
        busy(r, false); paint(r);
        setMsg(r, errText(err));
      });
    }
  }
  function onListChange(e) {
    var s = e.target.closest('select[data-opt]');
    if (!s) return;
    var r = rows[+s.closest('.nm-lb-dr__row').getAttribute('data-i')];
    var i = +s.getAttribute('data-opt');
    if (s.value) r.sel[i] = s.value; else delete r.sel[i];
    s.classList.remove('is-missing');
    setMsg(r, '');
    if (r.added) r.added = false;
    paint(r); paintAll();
  }

  function needChoice(r) {
    var v = variant(r);
    if (v) return v;
    var s = r.el.querySelector('select[data-opt]');
    Array.prototype.forEach.call(r.el.querySelectorAll('select[data-opt]'), function (x) { if (!x.value) x.classList.add('is-missing'); });
    setMsg(r, 'Choose a ' + (s ? r.p.options[+s.getAttribute('data-opt')].toLowerCase() : 'option') + ' first.');
    if (s) s.focus();
    return null;
  }
  function setMsg(r, t) { r.el.querySelector('.nm-lb-dr__msg').textContent = t; }
  function busy(r, on) { var b = r.el.querySelector('.nm-lb-dr__add'); b.disabled = on; if (on) { b.classList.add('is-busy'); b.textContent = 'Adding'; } }
  function errText(err) { return (err && (err.description || err.message)) || 'Could not add this piece. Try again.'; }

  function addAll() {
    var left = pending();
    var items = [], missing = null;
    left.forEach(function (r) {
      var v = variant(r);
      if (!v) { if (!missing) missing = r; return; }
      items.push({ id: v.id, quantity: 1 });
    });
    if (missing) {
      needChoice(missing);
      left.forEach(function (r) { if (!variant(r)) Array.prototype.forEach.call(r.el.querySelectorAll('select[data-opt]'), function (x) { if (!x.value) x.classList.add('is-missing'); }); });
      note.classList.add('is-error');
      var nMissing = left.filter(function (r) { return !variant(r); }).length;
      note.textContent = nMissing > 1 ? 'Choose your sizes above to add the full look.' : 'Choose a ' + missing.p.options[missing.other[0]].toLowerCase() + ' for ' + missing.p.title + ' to add the full look.';
      missing.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    note.classList.remove('is-error');
    allBtn.disabled = true;
    allBtn.textContent = 'Adding ' + items.length + (items.length === 1 ? ' piece' : ' pieces');
    var code = look.code;
    cartAdd(items).then(function () {
      left.forEach(function (r) { r.added = true; });
      var done = code ? fetch(ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      return done.then(function () {
        document.dispatchEvent(new CustomEvent('nm:lookbook:add-all', { bubbles: true, detail: { look: look.card.id, items: items, code: code || null } }));
        close();
        refreshCart(true, items.length);
      });
    }).catch(function (err) {
      allBtn.disabled = false;
      paintAll();
      note.classList.add('is-error');
      note.textContent = errText(err);
    });
  }

  function cartAdd(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); });
  }

  /* Uses the theme's own cart: "product:added" re-renders the cart and opens it; "cart:refresh" only re-renders */
  function refreshCart(openCart, qty) {
    if (openCart) document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: qty } }));
    else document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* ---------- Wire up ---------- */
  function init() {
    buildNav();
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nm-lb-card__btn');
      if (!btn) return;
      e.preventDefault();
      open(btn.closest('[data-nm-lb-look]'));
    });
    if (/^#look-/.test(location.hash)) {
      var card = document.getElementById(location.hash.slice(1));
      if (card && card.matches('[data-nm-lb-look]')) { card.scrollIntoView({ block: 'center' }); open(card, true); }
    }
    /* Theme editor: rebuild links when chapters change */
    document.addEventListener('shopify:section:load', buildNav);
    document.addEventListener('shopify:section:unload', function () { setTimeout(buildNav, 0); });
    document.addEventListener('shopify:section:reorder', buildNav);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
